import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { TaskQL, TaskData } from '../../providers/tasks/models';
import { TasksProvider } from '../../providers/tasks/tasks';
import { ENV } from '../../environments/environment';

@IonicPage()
@Component({
  selector: 'page-task-questions',
  templateUrl: 'task-questions.html'
})
export class TaskQuestionsPage {
  @ViewChild('selectInput') myInput: ElementRef;
  @ViewChild('numberInput') numberInput ;
  @ViewChild('input') invalid ;

  @ViewChild('qaBase') qaBase: ElementRef;

  private task: TaskQL;
  private feedback: string;

  public questions: any = [];
  private questionsMaster: any = [];
  public ready: boolean = false;
  private lateTime: number = 1000 * 60 * 60 * 3; // 3 Hours;
  private taskData: TaskData;

  hasGeyserManCode: boolean = false;
  geyserDateCodeValid: boolean = true;
  geyserDateCodeType: string = 'text';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private tasksProvider: TasksProvider,
    private platform: Platform
  ) {
    this.task = this.tasksProvider.getSelectedTask();
  }

  ngOnInit() {
    this.task = this.tasksProvider.getSelectedTask(); // this.navParams.get('task');
  }

  ionViewDidLoad() {}

  ionViewDidEnter() {
    this.taskData = this.tasksProvider.getTaskData(this.task.id);
    if (this.taskData.questions) {
      this.questions = this.taskData.questions;
    }
      if (this.taskData.feedback) this.feedback = this.taskData.feedback;
    if (!this.questions || this.questions.length <= 0) {
      this.questions = JSON.parse(JSON.stringify(this.task.questionnaire));

      this.setInputQuestionsAtEnd(this.questions);
      this.changeQuestionType(this.questions);
      this.questionsMaster = [...this.questions];
    }



    this.questionsForLateTasks();
    this.readyCheck();
    this._prepareQuestionsInAnExpectedOrder();

    if (!this.platform.is('cordova') && ENV.base.includes("dev")) {
      // auto fill when on desktop // testing
      for (let i = 0; i < this.questions.length; i++) {
        const question = this.questions[i];
        // auto answer populate if cordova is false;
        this.selectAnswer(
          question,
          question.options ? question.options[0].value : ''
        );
      }
    }
  }

  _prepareQuestionsInAnExpectedOrder() {
    // Map all hidden entries to their counterParts
    let newQuestionList = [];
    this.questions.map((question) => {

      // Is not hidden
      if (!question.hidden) { 
        let alreadyAdded = newQuestionList.filter(addedQuestion => { addedQuestion.label === question.label });
        if (alreadyAdded.length === 0) {
          if (question.type === 'optional' && question.tag) {
            let hasChild = this.findChildByTag(question.tag, question.label);
            // Is optional question
            newQuestionList.push(question);
            if (hasChild) {
              this.questions.map((pairedQuestion) => {
                if (pairedQuestion.tag === question.tag && pairedQuestion.label !== question.label) {
                  // Is optional hidden question
                  if (pairedQuestion.hidden === true) {
                    newQuestionList.push(pairedQuestion);
                  }
                }
              });
            }
          } else {
            // Is not optional question
            newQuestionList.push(question);
          }
        }
      }
    });

    this.questions = newQuestionList;
  }

  setInputQuestionsAtEnd(questions){
      let inputs;
      let checks;
      const nonInputs =  questions.filter(q => {
        let keepQuestion = true;
        let checkType = q.type.includes('input');
        if(checkType){
          if(!inputs) {
            inputs = [q];
          } else {
            inputs.push(q);
          }
          keepQuestion = false;
        }

        checkType = q.type.includes('checkbox');
        if(checkType){
          if(!checks) {
            checks = [q];
          } else {
            checks.push(q);
          }
          keepQuestion = false;
        }
        return keepQuestion;
      });
      let vals;
      if(nonInputs) vals = nonInputs;
      if(checks) vals = [...nonInputs, ...checks];
      if(inputs) vals = [...vals, ...inputs];
      if(vals.length > 0){
        vals = vals.filter(val => {return val});
      }
      if(vals.length > 0){
        this.questions =  vals;
      }
  }

  changeQuestionType(questions){
    let hasGeyserDateCode = false;
    questions.map(q => {
      if(q.tag === 'geyserMultiple' && q.type === 'input'){
        q.type = 'inputNumber';
      }

      this.removeGeyserDateCode(questions);
    });
  }

  removeGeyserDateCode(questions){
    this.questions = questions.filter(q => {
      if(q.tag === 'geyserDateCode'){
        return false;
      } else {
        return q;
      }
    })
  }

  addDateCodeSelector(){
    this.hasGeyserManCode = true;
    const question = {
      "default": "null",
      "label" : "Does the geyser have a manufacture code?",
      "tag" : "geyserManCode",
      "type" : "select",
      "options" : [
        {
          "title" : "Yes",
          "value" : "true",
        },
        {
          "title" : "No",
          "value" : "false",
        },
      ],
    }
    this.questions.splice(0, 0, question);
  }

  isSelected(answer) {
    let flag = answer.selected ? true : false;
    return flag;
  }

  readyCheck() {
    let flag = true;
    let hiddenflag = false;

    for (let i = 0; i < this.questions.length; i++) {
      let question = this.questions[i];
      let question_answered = false;
      let question_answer = false;
      let options = question.options;

      if (options && options.length > 0) {
        for (let a = 0; a < options.length; a++) {
          if (options[a].selected) {
            question_answered = true;
          }
        }
      } else if (question.value && question.value.length > 0) {
        // VALIDATE TEXT FIELDS
        question_answered = true;
      }

      // Check if optional questions (then hide / show child)
      if (question.type === 'optional' && question.child) {
        let child = this.findChildByTag(question.child, question.label);
        if (options && child) {
          for (let a = 0; a < options.length; a++) {
            if (
              (options[a].selected && options[a].value !== 'true') || !question_answered
            ) {
              hiddenflag = true;
              child.hidden = hiddenflag;
              child.value = '';

            } else if (
              question_answered && (options[a].selected && options[a].value === 'true')
            ) {
              hiddenflag = false;
              child.hidden = hiddenflag;
            }
          }
        }
      } else if (question.type === 'optional' && question.tag) {
        let child = this.findChildByTag(question.tag, question.label);
        if (child) {
          let findAnswer = false;
          options.map(option => { if (option.selected) { findAnswer = option.value === 'false' ? false : option.value === 'true' ? true : option.value; }});
          child.hidden = findAnswer ? false : true;
        }
      }

      if (!question_answered && !question.hidden && !question.label.includes('(select all that apply)')) {
        flag = false;
      }
    }

    this.ready = flag;
    return flag;
  }

  findChildByTag(tag, label) {
    return this.questions.filter(question => {
      return ((question.tag === tag) && (question.label != label));
    })[0];
  }

  selectAnswer(question, answer, shownext: boolean = false) {
    if(question.tag === 'geyserManCode'){
      if(answer === 'false'){
        this.hasGeyserManCode = false;
        this.geyserDateCodeType = 'date';
      } else {
        this.hasGeyserManCode = true;
        this.geyserDateCodeType = 'text';
      }

    } else if(question.tag === 'geyserDateCode'){
      this.dateCodeCheck(question.value);
      if(!this.geyserDateCodeValid) return;
    }

    if (question.tag && question.tag.length > 0 && question.type === 'optional') {
      const child = this.findChildByTag(question.tag, question.label);
      if (child) {
        const letHasAnswer = answer === 'true' ? true : answer === 'false' ? false : Boolean(answer);
        child.hidden = !letHasAnswer;
      }
    }

    if(question.type === 'inputNumber' && question.value.startsWith('-')){
      this.numberInput.setValue('')
    }

    let options = question.options;
    if (options) {
      for (let i = 0; i < options.length; i++) {
        let q_answer = options[i];
        if (q_answer.value === answer) {
          q_answer.selected = true;
        } else {
          q_answer.selected = false;
        }
      }
    }

    if (shownext) {
      // TODO: // hacky auto select next question if not filled in
      const allItems = this.qaBase.nativeElement.querySelectorAll('.questions-list ion-item');

      // filter node list old school way
      let items = [];
      for (const i in allItems) {
        if (
          allItems[i] &&
          allItems[i].classList &&
          !allItems[i].classList.contains('input-has-value')
        ) {
          items.push(allItems[i]);
        }
      }

      if (items && items.length > 0) {
        try {
          items[0].querySelector('ion-select').click();
        } catch (e) {
          // console.log('TODO: Experimental to check for ion-select');
        }
      }

      // question-item item item-block item-md item-select input-has-value item-input-has-value
      // .querySelectorAll('ion-select')
      // .filter(select => {
      //   return select;
      // })[0];
      // select.click();
      // .click()

      // for (const i in selects) {
      //   if (selects[i]) {
      //     try {
      //       console.log(selects[i].innerText);
      //     } catch (e) {
      //       // console.log(e);
      //     }
      //   }
      // }
    }
    this.readyCheck();
  }

  makeRadioValue(title) {
    return title.replace(/\s/g, '_');
  }

  selectRadioAnswer(question, answer, event) {
    let options = question.options;
    if (options) {
      for (let i = 0; i < options.length; i++) {
        let q_answer = options[i];

        if (q_answer.title == answer.title) {
          q_answer.selected = true;
        } else {
          q_answer.selected = false;
        }
      }
    }

    this.readyCheck();
  }

  selectCheckAnswer(question, answer,  shownext: boolean = false, box) {
    let options = question.options;
    if (options) {
      for (let i = 0; i < options.length; i++) {
        let q_answer = options[i];
        if (q_answer.title === box.title) {
          q_answer.selected = answer.checked;
        }
      }
    }

    if (shownext) {
      // TODO: // hacky auto select next question if not filled in
      const allItems = this.qaBase.nativeElement.querySelectorAll('.questions-list ion-item');

      // filter node list old school way
      let items = [];
      for (const i in allItems) {
        if (
          allItems[i] &&
          allItems[i].classList &&
          !allItems[i].classList.contains('input-has-value')
        ) {
          items.push(allItems[i]);
        }
      }

      if (items && items.length > 0) {
        try {
          items[0].querySelector('ion-select').click();
        } catch (e) {
          // console.log('TODO: Experimental to check for ion-select');
        }
      }
    }
    this.readyCheck();
  }

  getOptions(question) {
    return question.options;
  }
  getTitle(question) {
    return question.label;
  }

  updateTask() {
    this.questions = this.questions.filter(q => {
      if(q.tag !== 'geyserManCode'){
        return true;
      }
    }).map(q => {
      if(q.type.includes('input') && q.type !== 'input'){
        q.type = 'input'
      }
      return q;
    });


    this.tasksProvider
      .updateTaskData(this.task, 'questions', this.questions)
      .subscribe(resultQuestions => {
        let feedback =
          this.feedback && this.feedback.length > 0 ? this.feedback : ' ';
        this.tasksProvider
          .updateTaskData(this.task, 'feedback', feedback)
          .subscribe(resultFeedback => {
            this.navCtrl.pop();
          });
      });
  }

  questionsForLateTasks(){
    let timeDiff = (new Date().getTime()) - (new Date(this.task.assignedDate).getTime());
    const questionAdded = this.questions.find(question => {
      if(question.tag === 'taskLateComplete') return question;
    });

    if((timeDiff > this.lateTime) && !questionAdded){
      const question = {
        child: null,
        default: null,
        type: "optional",
        label: "Why is this task being completed late?",
        options: [
          {
          selected: false,
          title: "Power cut",
          value: "Power cut",
          __typename: "QuestionnaireInput_options"
          },
          {
          selected: false,
          title: "Difficult to access device",
          value: "Difficult to access device",
          __typename: "QuestionnaireInput_options"
          },
          {
          selected: false,
          title: "Client was late",
          value: "Client was late",
          __typename: "QuestionnaireInput_options"
          },
          {
          selected: false,
          title: "Previous task took longer than expected",
          value: "Previous task took longer than expected",
          __typename: "QuestionnaireInput_options"
          },
          {
          selected: false,
          title: "Incorrect address loaded",
          value: "Incorrect address loaded",
          __typename: "QuestionnaireInput_options"
          },
          {
          selected: false,
          title: "Vehicle broke-down",
          value: "Vehicle broke-down",
          __typename: "QuestionnaireInput_options"
          },
          {
          selected: false,
          title: "Other",
          value: "true",
          __typename: "QuestionnaireInput_options"
          },
        ],
        tag: "taskLateComplete",
        __typename: "QuestionnaireInput"
      }

      this.questions.unshift(question, {
        child: null,
        default: null,
        options: null,
        label: "Explain why this task is being completed late?",
        tag: "taskLateComplete",
        type: "input",
      });
    }
  }

  dateCodeCheck(value){

    if(this.geyserDateCodeType === 'text'){
      let valid = true;
      if(value.length != 6) valid = false;

      let num = Number(value.charAt(0) + "" + value.charAt(1))
      if(!Number.isInteger(num)) valid = false;
      if(num < 1 || num > 12) valid = false;
      if(Number.isInteger(value.charAt(0))) valid = false;
      if(Number.isInteger(value.charAt(1))) valid = false;

      if((value.charAt(3).toUpperCase() != value.charAt(3).toLowerCase()) !== true ) valid = false;
      if(value.charAt(3).toLowerCase().includes('o') || value.charAt(3).toLowerCase().includes('q')  ) valid = false;

      if(value.charAt(2) !== '-') valid = false;

      if(value.charAt(4) !== '-') valid = false;
      if(!((Number(value.charAt(5)) + 1 ) > 0)) valid = false;
      if((value.charAt(5).toUpperCase() != value.charAt(5).toLowerCase())) valid = false;

      this.geyserDateCodeValid = valid;

      setTimeout(() => {
        this.invalid.setFocus();
      },100);

    } else {
      if(value.length < 10){
        this.geyserDateCodeValid = false;
      } else {
        this.geyserDateCodeValid = true;
      }
      if(value){
        let selectedDate = new Date(value)
        selectedDate.setHours(0)
        selectedDate.setMinutes(0)
        let today = new Date()
        today.setHours(0)
        today.setMinutes(0)
        today.setSeconds(0)
        today.setMilliseconds(0)
        if(selectedDate.getTime() >= today.getTime() ){
          this.geyserDateCodeValid = false;
        }
      }
    }
  }

  disableDoneCheck(){
    return !this.ready
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-questions/task-questions.ts